import { NgModule } from '@angular/core';
import {ImpressumComponent} from '@modules/home/policies/pages/impressum/impressum.component';
import {AnbComponent} from '@modules/home/policies/pages/anb/anb.component';
import {AebComponent} from '@modules/home/policies/pages/aeb/aeb.component';
import {DataPrivacyComponent} from '@modules/home/policies/pages/data-privacy/data-privacy.component';
import {AbsichtserklaerungComponent} from '@modules/home/policies/pages/absichtserklaerung/absichtserklaerung.component';
import {StaticPagesHeaderComponent} from '@modules/home/policies/components/static-pages-header/static-pages-header.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {PoliciesRouting} from '@modules/home/policies/policies.routing';
import { OoeRaffleConditionsComponent } from './pages/participation-conditions/ooe-raffle-2021-conditions/ooe-raffle-conditions.component';
import { DefaultRaffleConditionsComponent } from './pages/participation-conditions/default-raffle-conditions/default-raffle-conditions.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PoliciesRouting,
  ],
  declarations: [
    DataPrivacyComponent,
    AbsichtserklaerungComponent,
    StaticPagesHeaderComponent,
    ImpressumComponent,
    AnbComponent,
    AebComponent,
    OoeRaffleConditionsComponent,
    DefaultRaffleConditionsComponent,
  ],
})
export class PoliciesModule { }
